import { useContext } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { ColorThemeContext } from '@shared/styles';

export interface MBSeparatorProps {
  // Color of the separator line. Default for native is gray border and for web
  // is gray light
  color?: string;

  // If set, the separator will be a thin vertical line instead of a thin
  // horizontal line. Default is false.
  vertical?: boolean;

  style?: StyleProp<ViewStyle>;
}

const styles = StyleSheet.create({
  vertical: {
    opacity: 0.25,
    width: 1,
    alignSelf: 'stretch',
  },
  horizontal: {
    opacity: 0.25,
    height: 1,
    width: '100%',
  },
});

export function MBSeparator({ vertical = false, color, style }: MBSeparatorProps) {
  const colors = useContext(ColorThemeContext);
  const backgroundColor = color || colors.foregroundInactive;
  const separatorStyle = vertical ? styles.vertical : styles.horizontal;

  return <MBView style={[separatorStyle, { backgroundColor }, style]} />;
}
